export const CHOOSE_STATUS_LABEL = 'Status wählen';
export const STATUS_HISTORY_LABEL = 'Status-Historie';
